import React from 'react';

export const SkeletonMetricCard = () => (
  <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1 animate-pulse">
    <div className="flex items-start space-x-3 mb-4">
      <div className="w-10 h-10 bg-muted rounded-lg"></div>
      <div className="flex-1">
        <div className="h-3 bg-muted rounded w-2/3 mb-2"></div>
        <div className="h-3 bg-muted rounded w-1/2"></div>
      </div>
    </div>
    <div className="h-8 bg-muted rounded w-1/2 mb-2"></div>
    <div className="h-3 bg-muted rounded w-3/4"></div>
  </div>
);

export const SkeletonChartCard = () => (
  <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1 animate-pulse">
    <div className="h-5 bg-muted rounded w-1/3 mb-4"></div>
    <div className="h-64 bg-muted rounded"></div>
    <div className="mt-4 flex space-x-4">
      <div className="h-3 bg-muted rounded w-1/4"></div>
      <div className="h-3 bg-muted rounded w-1/4"></div>
      <div className="h-3 bg-muted rounded w-1/4"></div>
    </div>
  </div>
);

export const SkeletonTable = () => (
  <div className="bg-card border border-border rounded-lg shadow-elevation-1 animate-pulse">
    <div className="p-4 border-b border-border">
      <div className="h-5 bg-muted rounded w-1/4"></div>
    </div>
    <div className="divide-y divide-border">
      {[...Array(5)]?.map((_, i) => (
        <div key={i} className="p-4 flex items-center space-x-4">
          <div className="w-8 h-8 bg-muted rounded-full"></div>
          <div className="flex-1 space-y-2">
            <div className="h-4 bg-muted rounded w-1/3"></div>
            <div className="h-3 bg-muted rounded w-1/2"></div>
          </div>
          <div className="h-6 bg-muted rounded w-16"></div>
        </div>
      ))}
    </div>
  </div>
);

const SkeletonLoader = ({ lines = 3, className = '' }) => (
  <div className={`animate-pulse space-y-3 ${className}`}>
    {[...Array(lines)]?.map((_, i) => (
      <div
        key={i}
        className="h-4 bg-muted rounded"
        style={{ width: `${100 - (i * 10)}%` }}
      />
    ))}
  </div>
);

export default SkeletonLoader;
